import { Container } from "@mui/material";
import { OffersListWidgetLazy } from "../../widgets/OffersListWidget/OffersListWidgetLazy";
import { useState } from "react";
import { UnitGroupListWidgetLazy } from "../../widgets/UnitGroupListWidget/UnitGroupListWidgetLazy";

const DEFAULT_PER_PAGE = 4;

export function ContentRendererOffersList({ bannersSearch, ...block }: any) {
  const [offerListProps] = useState(() => {
    const searchParams = new URLSearchParams((decodeURI(block.filterLink) || "").split("?")[1]);

    const params: {
      perPage: 4 | 12;
      cityIdContext?: number;
      forcedAttributeIds?: number[];
      hotelIdContext?: string;
      type?: "future";
      guestsCount: number;
      forcedArrivalDate?: string;
      forcedDepartureDate?: string;
    } = {
      perPage: DEFAULT_PER_PAGE,
      guestsCount: 2,
    };

    if (searchParams.get("cityId")) {
      params.cityIdContext = Number(searchParams.get("cityId"));
    }

    if (!searchParams.get("arrivalDate") || !searchParams.get("departureDate")) {
      params.type = "future";
    } else {
      params.forcedArrivalDate = searchParams.get("arrivalDate") as string;
      params.forcedDepartureDate = searchParams.get("departureDate") as string;
    }

    if (searchParams.has("hotelId")) {
      params.hotelIdContext = searchParams.get("hotelId") as string;
    }

    if (searchParams.has("perPage")) {
      params.perPage = Number(searchParams.get("perPage")) as 12;
    }

    if (searchParams.has("adults")) {
      params.guestsCount = Number(searchParams.get("adults")) as 2;
    }

    if (searchParams.has("filters")) {
      params.forcedAttributeIds = searchParams
        .get("filters")
        ?.split(",")
        .map((a) => Number(a))
        .filter(Boolean);
    }

    return params;
  });

  // Currently, offers do not support cityId filter.
  // Besides, offers do not work if complete date range is not specified.
  // Thus, for these cases, we fallback to unit group list.
  const fallbackToUnitGroupListWidget: boolean =
    offerListProps.cityIdContext != null || (!offerListProps.forcedArrivalDate && !offerListProps.forcedDepartureDate);

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      {fallbackToUnitGroupListWidget ? (
        <UnitGroupListWidgetLazy
          dataTestId="landing-unit-group-list"
          infinite
          perPage={offerListProps.perPage}
          cityIdContext={offerListProps.cityIdContext}
          hotelIdContext={offerListProps.hotelIdContext}
          forcedAttributeIds={offerListProps.forcedAttributeIds}
        />
      ) : (
        <OffersListWidgetLazy
          bannersSearch={bannersSearch}
          dataTestId="landing-offers-list"
          bannerBlockId="landingPage"
          showTotalPrice
          infinite
          guestsCount={offerListProps.guestsCount}
          perPage={offerListProps.perPage}
          cityIdContext={offerListProps.cityIdContext}
          hotelIdContext={offerListProps.hotelIdContext}
          type={offerListProps.type}
          forcedAttributeIds={offerListProps.forcedAttributeIds}
          forcedArrivalDate={offerListProps.forcedArrivalDate}
          forcedDepartureDate={offerListProps.forcedDepartureDate}
        />
      )}
    </Container>
  );
}
